import { environment, sentryDSN } from "../config";
import * as Sentry from "@sentry/react"; // Ensure you import Sentry from the correct source

export default function initializeSentry() {
  if (sentryDSN) {
    Sentry.init({
      dsn: sentryDSN,
      environment: environment,
      // https://docs.sentry.io/clients/javascript/tips/
      ignoreErrors: [
        // Random plugins/extensions
        "top.GLOBALS",
        // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
        "originalCreateNotification",
        "canvas.contentDocument",
        "MyApp_RemoveAllHighlights",
        "http://tt.epicplay.com",
        "Can't find variable: ZiteReader",
        "jigsaw is not defined",
        "ComboSearch is not defined",
        "http://loading.retry.widdit.com/",
        "atomicFindClose",
        // Facebook borked
        "fb_xd_fragment",
        // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
        // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
        "bmi_SafeAddOnload",
        "EBCallBackMessageReceived",
        // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
        "conduitPage",
        // Generic error code from errors outside the security sandbox
        // You can delete this if using raven.js > 1.0, which ignores these automatically.
        "Script error.",
        "Background Image 404: %23a",
        "Object(...) is not a function",
        "Object(r.b) is not a function. (In 'Object(r.b)({component:Object(n.a)(c,[a.b],o.a),configuration:{tagname:c}})', 'Object(r.b)' is an instance of Object)",
        "Object(r.b) is not a function",
        "Fetch of access token failed",
        "Class constructor h cannot be invoked without 'new'",
        "Cannot call a class constructor without |new|",
        '"undefined" is not valid JSON',
        "Fetch of access token failed",
      ],
      denyUrls: [
        // Facebook flakiness
        /graph\.facebook\.com/i,
        // Facebook blocked
        /connect\.facebook\.net\/en_US\/all\.js/i,
        // Woopra flakiness
        /eatdifferent\.com\.woopra-ns\.com/i,
        /static\.woopra\.com\/js\/woopra\.js/i,
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        // Other plugins
        /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
        /webappstoolbarba\.texthelp\.com\//i,
        /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
      ],
      allowUrls: ["edalnice.cz", "test.edalnice.cz", "dev.edalnice.cz", "preview.edalnice.cz", "localhost:3000"],
    });
  }
}
